import * as Utils from './utils';

export function init() {
	const debounce = (func) => {
	    var timer;
	    return function(event){
	        if(timer) clearTimeout(timer);
	        timer = setTimeout(func,100,event);
	    };
	}

	window.addEventListener("resize",debounce(function(e){
	    vh();
	}));

	vh();
}

export function vh() {
	if (
	    window.matchMedia("(max-width: 1024px)").matches ||
	    Utils.isMobile()
	) {
		const vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}
}